export const ActionTypes = {
  SHOW_BLOGS: "SHOW_BLOGS",
  BLOG_DETAIL: "BLOG_DETAIL",
  BLOG_COMMENTS: "BLOG_COMMENTS",
  REMOVE_SELECTED_BLOG: "REMOVE_SELECTED_BLOG",
  POST_BLOG_SUCCESS : "POST_BLOG_SUCCESS",
  POST_BLOG_FAILED : "POST_BLOG_FAILED",
};
